module.exports = __webpack_public_path__ + "img/saleClass-nodata.de9928cc.png";